import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import moment from "moment/moment";
import {
  Button,
  Card,
  Chip,
  Dialog,
  DialogContent,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { IoIosDocument } from "react-icons/io";
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import OpenDocument from "../../helpers/openDocument";
import { getFileMime } from "../../store/helpers/common_functions";
import { useHistory } from "react-router";
import a11yProps from "helpers/ay-props";
import TabPanel from "helpers/TabPanel";
import StatusLayout from "components/Status";
import TabBoxComponent from "components/UI/TabBox";

function RequestApproval({ SetSelectedMenu, approverId }) {
  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);
  const [fileView, setFileView] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [subTabValue, setSubTabValue] = useState(0);

  const history = useHistory();

  useEffect(() => {
    SetSelectedMenu({
      menu: "approval",
      title: "Approve Leave",
    });
  }, []);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Add this function to handle subtab changes
  const handleSubTabChange = (event, newValue) => {
    setSubTabValue(newValue);
  };

  // Get the status filter based on subtab value
  const getStatusFilter = () => {
    switch (subTabValue) {
      case 0:
        // Return all statuses except denied, canceled, approved, and on-leave
        return "-denied,-canceled,-approved,-on-leave"; // Using minus prefix to exclude these statuses
      case 1:
        return "approved,on-leave";
      case 2:
        // Specifically only denied and canceled statuses
        return "denied,canceled";
      default:
        return "all"; // Changed from empty string to 'all'
    }
  };

  const columns = [
    {
      name: "category.name",
      data: "category.name",
      label: "Category",
    },
    {
      name: "resource.names",
      data: "resource.names",
      label: "Requested By",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "leaveDays",
      data: "leaveDays",
      label: "Days Taken",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const leave = list[rowIndex];
          if (leave?.category?.type === "annual") {
            const startDate = new Date(leave?.startDate);
            const returnDate = new Date(leave?.returnDate);
            const daysTaken = Math.ceil(
              (returnDate - startDate) / (1000 * 60 * 60 * 24)
            );
            return daysTaken > 0 ? daysTaken : 0;
          }
          return null;
        },
      },
    },
    {
      name: "remainingDays",
      data: "remainingDays",
      label: "Days Remaining",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          list[rowIndex]?.category?.type === "annual"
            ? list[rowIndex]?.remainingDays
            : null,
      },
    },
    {
      name: "startDate",
      data: "startDate",
      label: "Start Date",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          list[rowIndex]?.category?.type === "annual" ? (
            <div>
              {list[rowIndex].annualStarts?.split(",")?.map((v) => (
                <div style={{ minWidth: "100px" }}>
                  {moment(v).format("YYYY-MMM-DD")}
                </div>
              ))}
            </div>
          ) : (
            moment(list[rowIndex]?.startDate).format("YYYY-MMM-DD")
          ),
      },
    },
    {
      name: "endDate",
      data: "endDate",
      label: "Return Date",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          list[rowIndex]?.category?.type === "annual" ? (
            <div>
              {list[rowIndex].annualEnds?.split(",")?.map((v) => (
                <div style={{ minWidth: "100px" }}>
                  {moment(v).format("YYYY-MMM-DD")}
                </div>
              ))}
            </div>
          ) : (
            moment(list[rowIndex]?.endDate).format("YYYY-MMM-DD")
          ),
      },
    },
    {
      name: "id",
      data: "id",
      label: "Support Document",
      options: {
        customBodyRender: (v) => {
          const obj = list?.find((vx) => vx.id === v);

          return obj?.supportDocument ? (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setFileView(obj);
              }}
              size={"small"}
              variant={"outlined"}
              startIcon={<IoIosDocument />}
            >
              View
            </Button>
          ) : null;
        },
      },
    },
    {
      name: "updatedAt",
      data: "updatedAt",
      label: "Submitted At",
      options: {
        customBodyRender: (v) => moment(v).format("YYYY-MMM-DD"),
      },
    },
    {
      name: "status",
      data: "status",
      label: "Status",
      options: {
        customBodyRender: (v) => <StatusLayout status={v} />,
      },
    },
  ];
  const otherColumns = [
    {
      name: "category.name",
      data: "category.name",
      label: "Category",
    },
    {
      name: "resource.names",
      data: "resource.names",
      label: "Requested By",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "leaveDays",
      data: "leaveDays",
      label: "Days Taken",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          moment(list[rowIndex]?.endDate).diff(
            list[rowIndex]?.startDate,
            "days"
          ),
      },
    },

    {
      name: "startDate",
      data: "startDate",
      label: "Start Date",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          moment(list[rowIndex]?.startDate).format("YYYY-MMM-DD"),
      },
    },
    {
      name: "endDate",
      data: "endDate",
      label: "Return Date",
      options: {
        customBodyRenderLite: (dataIndex, rowIndex) =>
          moment(list[rowIndex]?.endDate).format("YYYY-MMM-DD"),
      },
    },

    {
      name: "id",
      data: "id",
      label: "Support Document",
      options: {
        customBodyRender: (v) => {
          const obj = list?.find((vx) => vx.id === v);

          return obj?.supportDocument ? (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setFileView(obj);
              }}
              size={"small"}
              variant={"outlined"}
              startIcon={<IoIosDocument />}
            >
              View
            </Button>
          ) : null;
        },
      },
    },
    {
      name: "updatedAt",
      data: "updatedAt",
      label: "Submitted At",
      options: {
        customBodyRender: (v) => moment(v).format("YYYY-MMM-DD"),
      },
    },
    {
      name: "status",
      data: "status",
      label: "Status",
      options: {
        customBodyRender: (v) => (
          <Chip
            label={v}
            color={
              v === "approved"
                ? "success"
                : v === "denied"
                ? "error"
                : "default"
            }
          />
        ),
      },
    },
  ];
  const onRowClick = (data, { rowIndex }) => {
    history.push(`/admin/permission/details/${list[rowIndex].id}`);
  };

  return (
    <div>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={fileView !== null}
        onClose={() => setFileView(null)}
      >
        <DialogContent>
          {fileView !== null && (
            <OpenDocument
              downloadable={true}
              document={fileView?.supportDocument}
              name={"supportDocument"}
              specialName={fileView?.supportDocument}
              type={"permission-doc"}
              mimeType={getFileMime(fileView?.supportDocument)}
            />
          )}
        </DialogContent>
      </Dialog>
      <Card>
        <TabBoxComponent
          selectedValue={subTabValue}
          handleTabChange={handleSubTabChange}
          tabList={[
            {
              label: "Pending",
              tabValue: 0,
            },
            {
              label: "Approved",
              tabValue: 1,
            },
            {
              label: "Denied/Canceled",
              tabValue: 2,
            },
          ]}
        />
        <DatatableComponent
          search={false}
          viewColumns={false}
          searchfield={true}
          onRowClick={onRowClick}
          processData={(data) => {
            setList(data.data);
            return data;
          }}
          url={`/api/approval/datatable/my-approvals?count=${count}&type=${getStatusFilter()}`}
          columns={columns}
        />
      </Card>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestApproval);
